const toast = {
  message: {
    success: 'הצלחה!',
    error: 'משהו השתבש.',
  },
};

export default toast;
